import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=665e5d26&scoped=true&"
import script from "./ShopItem.vue?vue&type=script&lang=js&"
export * from "./ShopItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=665e5d26&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e5d26",
  null
  
)

export default component.exports